export const urls = {
  loyaltyProgramBanners: () => "/api/client/v1/loyalty-programs/marketing-banners/",
};

export const keys = {
  all: () => ["loyalty-programs-all"],
  loyaltyProgramBanners: () => [...keys.all(), "loyalty-program-banners"],
  loyaltyProgramBannersLists: () => [...keys.loyaltyProgramBanners(), "list"],
};
